import { useMemo } from 'react';
import type { CanvasStickyNote } from '../../sweep-canvas/canvas-types';
import type { TransientFunnel } from '../funnelMapCanvasTypes';
import type { FunnelMapStickyNote } from '../../../types/FunnelMapStickyNote';

export const useCalculateStickyNotesNodes = ({
  stickyNotesMap,
  transientFunnel,
}: {
  stickyNotesMap?: { [id: string]: FunnelMapStickyNote };
  transientFunnel?: TransientFunnel;
}) => {
  return useMemo(() => {
    if (!stickyNotesMap && !transientFunnel) {
      return { stickyNotesNodes: [] };
    }

    const stickyNotesNodes = Object.entries(stickyNotesMap || {}).map(([id, stickyNote]) => {
      const canvasStickyNote: CanvasStickyNote = {
        nodeType: 'stickyNote',
        id: id,
        color: stickyNote.backgroundColor,
        richText: stickyNote.richText,
        width: stickyNote.width,
        height: stickyNote.height,
        xyPosition: stickyNote.xyPosition,
        sectionId: stickyNote.sectionId,
        textScale: stickyNote.textScale ?? 1,
      };
      return canvasStickyNote;
    });

    return { stickyNotesNodes };
  }, [stickyNotesMap, transientFunnel]);
};
